module.exports = __webpack_public_path__ + "static/media/sharee.86436bb4.png";